import { TimeUnit } from '@web/birdz-angular';
import { KpiType } from 'app/types/kpi-type.type';

export interface Kpi {
  id: string;
  label: string;
  device_types: string[];
  threshold: number | null;
  weekly_day: number | null;
  weekly_depth: number | null;
  monthly_day: number | null;
  monthly_depth: number | null;
  daily_display: boolean;
  hourly_display: boolean;
  hourly_period: number | null; // in minutes, for kpis calculated on sub-daily slots
  weekly_display: boolean;
  monthly_display: boolean;
  ytd_display: boolean;
  has_ytd_equivalent: boolean;
  raw_display: boolean;
  has_raw_equivalent: boolean;
  technology: string;
  type: KpiType;
  admin_birdz_display: boolean;
}

/**
 * Kpis whose values are numbers (rates or numbers of days) instead of states:
 * YTD kpis, and kapta daily kpis which are rates per pds
 */
export function hasNumericValues(kpi: Kpi): boolean {
  return kpi.ytd_display || kpi.technology === 'KAPTA';
}

export function isKpiDisplayableForGranularity(kpi: Kpi, granularity: TimeUnit): boolean {
  switch (granularity) {
    case 'hour':
      return !!kpi.hourly_display;
    case 'day':
      return !!(kpi.daily_display || kpi.ytd_display);
    case 'week':
      return !!kpi.weekly_display;
    case 'month':
      return !!kpi.monthly_display;
    default:
      return false;
  }
}
